(function () {
  'use strict';

  function money(cents) {
    try {
      return new Intl.NumberFormat('he-IL', { style: 'currency', currency: window.RV_CURRENCY || 'ILS' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ₪';
    }
  }

  function sized(url, w) {
    if (!url) return '';
    var clean = String(url).replace(/([?&])width=\d+/g, '$1').replace(/[?&]$/, '');
    return clean + (clean.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function initGallery(root) {
    if (root.getAttribute('data-rv-init') === '1') return;
    root.setAttribute('data-rv-init', '1');
    var track = root.querySelector('[data-gal-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gal-thumb]'));
    var prev = root.querySelector('[data-gal-prev]');
    var next = root.querySelector('[data-gal-next]');
    if (!track) return;

    function slideWidth() { return track.clientWidth || 1; }
    function currentIndex() { return Math.round(Math.abs(track.scrollLeft) / slideWidth()); }

    /* In RTL with mandatory scroll-snap, Chrome ignores animated scrolls of this
       track (both CSS smooth behaviour and per-frame writes get snapped back to 0),
       so programmatic moves are written instantly with scroll-behavior forced off.
       Touch swiping still uses the browser's own snapping. */
    function setLeft(v) {
      var keep = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = v;
      track.style.scrollBehavior = keep;
    }

    function mark(i) {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      var active = thumbs[i];
      if (active && active.parentNode) {
        var p = active.parentNode;
        var pr = p.getBoundingClientRect();
        var ar = active.getBoundingClientRect();
        var delta = (ar.left + ar.width / 2) - (pr.left + pr.width / 2);
        if (Math.abs(delta) > 2) {
          var keep = p.style.scrollBehavior;
          p.style.scrollBehavior = 'auto';
          p.scrollLeft = p.scrollLeft + delta;
          p.style.scrollBehavior = keep;
        }
      }
    }

    function goTo(i) {
      var max = track.children.length - 1;
      i = Math.max(0, Math.min(max, i));
      var rtl = getComputedStyle(track).direction === 'rtl';
      var slide = track.children[i];
      var img = slide ? slide.querySelector('img') : null;
      if (img && img.loading === 'lazy') { img.loading = 'eager'; }
      setLeft((rtl ? -1 : 1) * i * slideWidth());
      mark(i);
    }

    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });
    track.addEventListener('scroll', function () { mark(currentIndex()); }, { passive: true });
    window.addEventListener('resize', function () { mark(currentIndex()); }, { passive: true });
    mark(0);

    root.rvGoTo = goTo;
    window.RV_GALLERY = root;
  }

  function initQty(root) {
    if (root.getAttribute('data-rv-init') === '1') return;
    root.setAttribute('data-rv-init', '1');
    var input = root.querySelector('[data-qty-input]');
    if (!input) return;
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-step]');
      if (!b) return;
      e.preventDefault();
      var v = parseInt(input.value, 10) || 1;
      v += parseInt(b.getAttribute('data-qty-step'), 10);
      input.value = Math.max(1, v);
    });
  }

  function initVariants(form) {
    var data = form.querySelector('[data-variant-json]');
    if (!data) return;
    var variants = [];
    try { variants = JSON.parse(data.textContent || '[]'); } catch (e) { return; }
    var idInput = form.querySelector('[data-variant-id]');
    var priceNow = document.querySelector('[data-price-now]');
    var priceWas = document.querySelector('[data-price-was]');
    var submit = form.querySelector('[data-atc]');
    var label = document.querySelector('[data-option-value]');

    function update(moveGallery) {
      var chosen = form.querySelector('input[name="rv-option"]:checked');
      if (!chosen) return;
      var v = variants.filter(function (x) { return String(x.id) === String(chosen.value); })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (label) label.textContent = v.title;
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = money(v.compare_at_price);
          priceWas.hidden = false;
        } else { priceWas.hidden = true; }
      }
      form.setAttribute('data-rv-unavailable', v.available ? '0' : '1');
      if (submit) {
        submit.disabled = !v.available;
        var t = submit.querySelector('[data-atc-text]');
        if (t) t.textContent = v.available ? submit.getAttribute('data-label') : 'אזל מהמלאי';
      }
      if (moveGallery && v.mi > 0) {
        var gal = window.RV_GALLERY || document.querySelector('[data-gallery]');
        if (gal && gal.rvGoTo) gal.rvGoTo(v.mi - 1);
      }
    }
    form.addEventListener('change', function (e) { if (e.target.name === 'rv-option') update(true); });
    update(false);
  }

  /* ---------- cart drawer (Moodie-style) ----------
     Opening from the header icon only reads /cart.js: it never adds or changes a line.
     "הוספה לסל" keeps adding; if that brings a line above 1 the drawer says so. */
  var cfg = { productId: 0, variantIds: [], compare: 0, propName: '', propValue: '', continueUrl: '/', moneyFormat: '' };
  var lastCart = null;

  function readCfg() {
    var n = document.querySelector('[data-cart-config]');
    if (!n) return;
    try {
      var c = JSON.parse(n.textContent || '{}');
      for (var k in c) { if (Object.prototype.hasOwnProperty.call(c, k) && c[k] != null) cfg[k] = c[k]; }
    } catch (e) {}
  }

  function fmt(cents) {
    var f = cfg.moneyFormat;
    if (!f) return money(cents);
    var v = (cents / 100);
    function grp(x, d, t, s) {
      var p = x.toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return p.join(s);
    }
    return String(f).replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return grp(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return grp(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(v, 0, '.', ',');
      return grp(v, 2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  }

  var ICON_TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>';

  function isGiftLine(it) { return cfg.productId && String(it.product_id) === String(cfg.productId); }

  function lineHtml(it, i) {
    var line = i + 1;
    var gift = isGiftLine(it);
    var unitWas = gift && cfg.compare > it.final_price ? cfg.compare
      : (it.original_price > it.final_price ? it.original_price : 0);
    if (!unitWas && it.compare_at_price && it.compare_at_price > it.final_price && !gift) unitWas = it.compare_at_price;
    var was = unitWas ? unitWas * it.quantity : 0;
    var pct = unitWas ? Math.round((unitWas - it.final_price) / unitWas * 100) : 0;
    var img = it.image ? '<img src="' + esc(sized(it.image, 200)) + '" width="68" height="68" alt="" loading="lazy">' : '';
    var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="rvc-li__v">' + esc(it.variant_title) + '</div>' : '';
    var html = '<div class="rvc-line">' +
      '<div class="rvc-li">' +
      '<a class="rvc-li__img" href="' + esc(it.url) + '">' + img + '</a>' +
      '<div class="rvc-li__main">' +
      '<a class="rvc-li__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + vt +
      '<div class="rvc-qty">' +
      '<button type="button" data-line="' + line + '" data-to="' + (it.quantity - 1) + '" aria-label="הפחתת כמות">&minus;</button>' +
      '<span aria-live="polite">' + it.quantity + '</span>' +
      '<button type="button" data-line="' + line + '" data-to="' + (it.quantity + 1) + '" aria-label="הוספת כמות">+</button>' +
      '</div></div>' +
      '<div class="rvc-li__side">' +
      '<button type="button" class="rvc-li__rm" data-line="' + line + '" data-to="0" aria-label="הסרה מהסל" title="הסרה מהסל">' + ICON_TRASH + '</button>' +
      '<div class="rvc-li__prices">' + (was ? '<s class="rvc-li__was">' + fmt(was) + '</s>' : '') +
      '<span class="rvc-li__now">' + fmt(it.final_line_price) + '</span></div>' +
      (pct > 0 ? '<span class="rvc-li__save">חיסכון ' + pct + '%</span>' : '') +
      '</div></div>';
    if (gift) {
      var tpl = document.querySelector('[data-cart-gifts]');
      if (tpl) html += tpl.innerHTML;
    }
    return html + '</div>';
  }

  var drawer = {
    el: null,
    open: function () {
      if (!this.el) return;
      this.el.classList.add('is-open');
      document.body.classList.add('rvc-lock');
      var c = this.el.querySelector('.rvc__close');
      if (c) setTimeout(function () { try { c.focus({ preventScroll: true }); } catch (e) {} }, 60);
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      document.body.classList.remove('rvc-lock');
      this.notice('');
    },
    busy: function (on) { if (this.el) this.el.classList.toggle('is-busy', !!on); },
    notice: function (msg) {
      var n = this.el && this.el.querySelector('[data-cart-notice]');
      if (!n) return;
      n.textContent = msg || '';
      n.hidden = !msg;
    },
    render: function (cart) {
      if (!cart || !cart.items) return;
      lastCart = cart;
      document.querySelectorAll('[data-cart-count]').forEach(function (count) {
        count.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      });
      document.querySelectorAll('[data-cart-icon]').forEach(function (a) {
        a.setAttribute('aria-label', cart.item_count ? 'סל הקניות, ' + cart.item_count + ' פריטים' : 'סל הקניות');
      });
      if (!this.el) return;
      var hc = this.el.querySelector('[data-cart-headcount]');
      if (hc) hc.textContent = cart.item_count ? ' • ' + cart.item_count : '';
      var total = this.el.querySelector('[data-cart-total]');
      if (total) total.textContent = fmt(cart.total_price);
      var foot = this.el.querySelector('[data-cart-foot]');
      if (foot) foot.hidden = !cart.items.length;
      this.el.classList.toggle('is-empty', !cart.items.length);
      var body = this.el.querySelector('[data-cart-body]');
      if (!body) return;
      if (!cart.items.length) {
        body.innerHTML = '<div class="rvc-empty"><p>הסל שלך ריק.</p>' +
          '<a class="rvc-empty__btn" href="' + esc(cfg.continueUrl) + '" data-cart-continue>המשך בקנייה</a></div>';
        return;
      }
      body.innerHTML = cart.items.map(lineHtml).join('');
    }
  };

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  var drawerDocBound = false;

  function initDrawer() {
    readCfg();
    var el = document.querySelector('[data-cart-drawer]');
    drawer.el = el;
    if (el && el.getAttribute('data-rv-init') !== '1') {
      el.setAttribute('data-rv-init', '1');
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-close]') || e.target.hasAttribute('data-cart-overlay')) { drawer.close(); return; }
        var cont = e.target.closest('[data-cart-continue]');
        if (cont && cont.pathname === location.pathname) { e.preventDefault(); drawer.close(); return; }
        var q = e.target.closest('[data-line]');
        if (q) {
          if (q.disabled || el.classList.contains('is-busy')) return;
          q.disabled = true;
          drawer.busy(true);
          drawer.notice('');
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ line: parseInt(q.getAttribute('data-line'), 10), quantity: Math.max(0, parseInt(q.getAttribute('data-to'), 10)) })
          }).then(function (r) {
            return r.json().then(function (j) { if (!r.ok || !j || !j.items) throw j; return j; });
          })
            .then(function (c) { drawer.render(c); })
            .catch(function (j) {
              /* A failed change (e.g. the cart was changed in another tab) must never leave
                 a broken total: show why and reload the real cart. */
              q.disabled = false;
              return fetchCart().then(function (c) {
                drawer.render(c);
                drawer.notice((j && j.status === 422 && j.description) || 'לא הצלחנו לעדכן את הכמות. הסל עודכן, אפשר לנסות שוב.');
              });
            })
            .catch(function () {})
            .then(function () { drawer.busy(false); });
        }
      });
    }
    if (!drawerDocBound) {
      drawerDocBound = true;
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-cart-toggle]');
        if (!t) return;
        /* On /cart itself the icon simply reloads the page, so the page never shows stale lines. */
        if (document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        drawer.notice('');
        drawer.busy(true);
        drawer.open();
        fetchCart().then(function (c) { drawer.render(c); }).catch(function () {}).then(function () { drawer.busy(false); });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer.close(); });
      /* Back/forward cache: a page restored from history refreshes the badge. */
      window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart().then(function (c) { drawer.render(c); }).catch(function () {}); });
    }
    fetchCart().then(function (c) { drawer.render(c); }).catch(function () {});
  }

  function qtyOf(cart, variantId) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (s, it) { return s + (String(it.variant_id) === String(variantId) ? it.quantity : 0); }, 0);
  }

  /* Gift line in checkout: a visible line item property on the gift product. It never
     changes the price. It is left out when the same variant is already in the cart
     without it, so the unit joins that line instead of opening a second one. */
  function withGiftProperty(fd) {
    var multi = !fd.get('id') && fd.get('items[0][id]');
    var id = fd.get('id') || fd.get('items[0][id]');
    if (!id || !cfg.propName || !cfg.propValue) return fd;
    var ids = (cfg.variantIds || []).map(String);
    if (ids.indexOf(String(id)) === -1) return fd;
    var plain = lastCart && lastCart.items && lastCart.items.some(function (it) {
      return String(it.variant_id) === String(id) && !(it.properties && it.properties[cfg.propName]);
    });
    if (!plain) fd.append((multi ? 'items[0][properties][' : 'properties[') + cfg.propName + ']', cfg.propValue);
    return fd;
  }

  function formError(form, msg) {
    var box = form.querySelector('[data-atc-error]');
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-atc-error', '');
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:10px 0 0;font-size:14px;line-height:1.5;color:#c92a2a;text-align:center';
      form.appendChild(box);
    }
    box.textContent = msg || '';
    box.hidden = !msg;
  }

  function initForm(form) {
    if (form.getAttribute('data-rv-form') === '1') return;
    form.setAttribute('data-rv-form', '1');
    var busy = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      /* One request at a time: repeated taps on the main or the sticky button
         must not add the product more than once. */
      if (busy || form.getAttribute('data-rv-unavailable') === '1') return;
      busy = true;
      var btn = form.querySelector('[data-atc]');
      var sticky = document.querySelector('[data-sticky-btn]');
      if (btn) btn.disabled = true;
      if (sticky) sticky.disabled = true;
      formError(form, '');
      var raw = new FormData(form);
      var idField = form.querySelector('[data-variant-id]');
      var addedId = raw.get('id') || raw.get('items[0][id]') || (idField && idField.value);
      /* The product is already in the cart: a tap on "הוספה לסל" (main, sticky or
         final button) only opens the cart. A second unit is added with the + in the cart,
         so a shopper who taps it just to get back to the cart is never charged twice. */
      fetchCart()
        .catch(function () { return lastCart; })
        .then(function (c) {
          if (c) drawer.render(c);
          if (c && addedId && qtyOf(c, addedId) > 0) return { opened: true, cart: c };
          var fd = withGiftProperty(raw);
          return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
            .then(function (r) {
              return r.json().then(function (j) {
                if (!r.ok) {
                  var err = new Error((j && (j.description || j.message)) || '');
                  err.rvCart = true;
                  throw err;
                }
                return j;
              });
            })
            .then(function () { return fetchCart(); })
            .then(function (c2) { return { cart: c2 }; });
        })
        .then(function (res) {
          drawer.render(res.cart);
          drawer.notice('');
          drawer.open();
        })
        .catch(function (err) {
          if (err && err.rvCart) {
            formError(form, err.message || 'לא הצלחנו להוסיף את המוצר לסל. נסו שוב.');
          } else {
            window.location.href = '/cart';
          }
        })
        .then(function () {
          busy = false;
          if (sticky) sticky.disabled = false;
          if (btn) btn.disabled = form.getAttribute('data-rv-unavailable') === '1';
        });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-sticky]');
    var anchor = document.querySelector('[data-atc]');
    if (!bar || !anchor) return;
    if (bar.getAttribute('data-rv-init') === '1') return;
    bar.setAttribute('data-rv-init', '1');
    document.body.classList.add('rv-has-sticky');
    function update() {
      bar.classList.toggle('is-on', anchor.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-sticky-btn]')) {
        var f = document.querySelector('[data-product-form]');
        if (!f) return;
        if (f.requestSubmit) { f.requestSubmit(); } else { f.dispatchEvent(new Event('submit', { cancelable: true })); }
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-qty]').forEach(initQty);
    document.querySelectorAll('[data-product-form]').forEach(function (f) {
      if (f.getAttribute('data-rv-form') !== '1') initVariants(f);
      initForm(f);
    });
    initDrawer();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
